<template>
  <div class="team-icon-wrapper" :class="{'small': small}">
    <img
      v-if="getURL(team)"
      class="team-icon"
      :class="{'small': small}"
      :src="getURL(team)"
    >
    <div
      v-else
      class="team-icon"
      :class="{
        'default-team-icon': sideMenu ? selected : true,
        'not-selected-team-icon': sideMenu ? !selected : false,
        'small': small,
      }"
    >
      <p>
        {{ firstLetter(team.name) }}
      </p>
    </div>
  </div>
</template>

<script>
import * as UTILS from '@/components/utils.js'

export default {
  components: {
  },
  props: {
    team: {
      default () {
        return {name: '', logo: undefined}
      },
      type: Object,
    },
    sideMenu:{
      default: false,
      type: Boolean,
    },
    selected:{
      default: false,
      type: Boolean,
    },
    small:{
      default: false,
      type: Boolean,
    }
  },
  data() {
    return {}
  },
  methods: {
    firstLetter(teamName) {
      return teamName ? teamName.charAt(0).toUpperCase() : ''
    },
    getURL(team) {
      return team.logo ? team.logo._url : null
    },
  },
}
</script>

<style lang="scss" scoped>
.team-icon-wrapper {
  width: 22px;
  height: 22px;

  &.small {
    width: 14px;
    height: 14px;
  }
}
.team-icon {
  //vertical-align: middle;
  line-height: 22px;
  width: 22px;
  height: 22px;
  border-radius: 50px;
  object-fit: cover;

  &.small {
    width: 14px;
    height: 14px;
    line-height: 14px;
  }

  &.default-team-icon {
    background-color: $blue;
    display: flex;
    box-shadow: 0 0 1px 0px white inset, 0 0 1px 0px white;
    p {
      display: flex;
      font-family: $bold;
      width: 100%;
      font-size: 14px;
      color: #ffffff;
      align-items: center;
      justify-content: center;
      text-align: center;
      vertical-align: middle;
      margin: 0 0 0 0;
    }
    &.small {
      p { font-size: 12px; }
    }
  }
  &.not-selected-team-icon {
    border: 1px solid $black;
    display: flex;
    box-shadow: 0 0 1px 0px white inset, 0 0 1px 0px white;
    p {
      display: flex;
      font-family: $bold;
      width: 100%;
      font-size: 14px;
      color: $black;
      align-items: center;
      justify-content: center;
      text-align: center;
      vertical-align: middle;
      margin: 0 0 0 0;
    }
    &.small {
      p { font-size: 12px; }
    }
  }
}
</style>
